import adminImg from "../assets/images/admin.PNG";
import trustcatcherImg from "../assets/images/trustcatcher.PNG";
import shortscrafterImg from "../assets/images/shortscrafter.JPG";
import padsImg from "../assets/images/pads.PNG";

export const initialDraggableList = [
  {
    id: 4,
    status: false,
    zIndex: 1000,
    projectName: "Trust Catcher",
    bounds: { left: 0, top: 0, right: 985, bottom: 386 },
    boundsMedium: { left: 0, top: 0, right: 785, bottom: 386 },
    boundsSmall: { left: 0, top: 0, right: 535, bottom: 386 },
    defaultPosition: { x: 50, y: 50 },
    defaultPositionSmall: { x: 50, y: 50 },
    minimalizeStatus: false,
    projectImage: trustcatcherImg,
    wordpress: false,
    buttonLive: "https://www.trustcatcher.com/",
    buttonGithub: "https://github.com/JakubKomorowski/testimonials",
    description:
      "I'm during the development of SaaS project that will help webmasters to collect, manage and publish customer's testimonials",
    skills: ["Next", "Firebase", "TypeScript", "Tailwind", "Stripe", "Sanity"],
  },
  {
    id: 3,
    status: false,
    zIndex: 1000,
    projectName: "ShortsCrafter",
    bounds: { left: 0, top: -400, right: 985, bottom: -14 },
    boundsMedium: { left: 0, top: -400, right: 785, bottom: -14 },
    boundsSmall: { left: 0, top: -400, right: 535, bottom: -14 },
    defaultPosition: { x: 100, y: -295 },
    defaultPositionSmall: { x: 100, y: -295 },
    minimalizeStatus: false,
    projectImage: shortscrafterImg,
    wordpress: false,
    buttonLive: "https://shortscrafter.com/",
    buttonGithub: "",
    description:
      "ShortsCrafter is a SaaS platform that allows users to create short videos with AI.",
    skills: [
      "Next",
      "Tailwind",
      "TypeScript",
      "Stripe",
      "Inngest",
      "Firebase",
      "Sanity",
    ],
  },
];
